<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" size="small" :inline="true">

      <el-form-item label="用户昵称" prop="name">
        <el-input
          v-model="queryParams.nickName"
          placeholder="请输入"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="目的地" prop="url">
        <el-select
          v-model="queryParams.areaId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入城市"
          :remote-method="remoteMethod"
          :loading="cityLoading">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input v-show="false"
          v-model="queryParams.planEndTime"
          placeholder="请输入"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
        <el-input v-show="false"
          v-model="queryParams.planStartTime"
          placeholder="请输入"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="时间段" prop="url">
        <el-date-picker
          v-model="selectDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder="请选择"
          @change="dateChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          @keyup.enter.native="handleQuery">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="人数" prop="url">
        <el-input
          v-model="queryParams.peopleNum"
          placeholder="请输入"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="费用" prop="url">
        <el-select v-model="queryParams.cost" placeholder="请选择" clearable style="width: 240px" @keyup.enter.native="handleQuery">
          <el-option label="AA" :value="1"></el-option>
          <el-option label="你请" :value="3"></el-option>
          <el-option label="我请" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
      <br/>
      <el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
<!--        <el-button type="success" icon="el-icon-edit" :disabled="single" @click="handleUpdate">修改</el-button>-->
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">删除</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="pageList" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column label="序号" type="index" width="100"/>
      <el-table-column label="用户昵称" prop="nickName" :show-overflow-tooltip="true" width="200"/>
      <el-table-column label="目的地" prop="areaName" :show-overflow-tooltip="true" width="250"/>
      <el-table-column label="人数" prop="peopleNum" :show-overflow-tooltip="true" width="100"/>
      <el-table-column label="费用" prop="cost" :show-overflow-tooltip="true" :formatter="costFormat" width="100"/>
      <el-table-column label="时间段" prop="planStartTime" :formatter="planTimeFormat" :show-overflow-tooltip="true"
                       width="200"/>
      <el-table-column label="发布时间" prop="createTime" :show-overflow-tooltip="true"/>
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status==0"
            type="text"
            @click="handleStatusChange(scope.row)"
          >禁用
          </el-button>
          <el-button
            v-if="scope.row.status==1"
            type="text"
            @click="handleStatusChange(scope.row)"
          >启用
          </el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="pagination.total>0"
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.limit"
      @pagination="handleQuery"
    />

    <!-- 添加或修改打招呼配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="模拟用户" >
          <el-select v-model="form.userId" filterable placeholder="请选择">
            <el-option
              v-for="item in optionsUser"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目的地" >
          <el-select
            v-model="form.areaId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入城市"
            :remote-method="remoteMethod"
            :loading="cityLoading">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人数" >
          <el-input v-model="form.peopleNum" type="number" placeholder="请输入打招呼内容"/>
        </el-form-item>
        <el-form-item label="时间" >
          <el-select v-model="form.timeType" placeholder="请选择" clearable style="width: 240px">
            <el-option label="近期出发" :value="1"></el-option>
            <el-option label="某个周末" :value="2"></el-option>
            <el-option label="具体时间" :value="3" ></el-option>
            <el-option label="可商议" :value="4" ></el-option>
            <el-option label="说走就走" :value="5" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划开始时间" >
          <el-date-picker
            v-model="form.planStartTime"
            type="date"
            placeholder="请选择"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="计划结束时间" >
          <el-date-picker
            v-model="form.planEndTime"
            type="date"
            placeholder="请选择"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="费用" >
          <el-select v-model="form.cost" placeholder="请选择" clearable style="width: 240px">
            <el-option label="AA" :value="2"></el-option>
            <el-option label="你请" :value="1"></el-option>
            <el-option label="我请" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出行方式" >
          <el-select v-model="form.travel" placeholder="请选择" clearable style="width: 240px">
            <el-option label="自驾" :value="1"></el-option>
            <el-option label="跟团" :value="2"></el-option>
            <el-option label="自由行" :value="3" ></el-option>
            <el-option label="不限" :value="4" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialog.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {list, detail, update, add, del,getSimulationOptions,patch,getCityOptions} from '@/api/dynamic'

export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      cityLoading:false,
      options: [],
      optionsUser:[],
      value: [],
      list: [],
      states: ["Alabama", "Alaska", "Arizona",
        "Arkansas", "California", "Colorado",
        "Connecticut", "Delaware", "Florida",
        "Georgia", "Hawaii", "Idaho", "Illinois",
        "Indiana", "Iowa", "Kansas", "Kentucky",
        "Louisiana", "Maine", "Maryland",
        "Massachusetts", "Michigan", "Minnesota",
        "Mississippi", "Missouri", "Montana",
        "Nebraska", "Nevada", "New Hampshire",
        "New Jersey", "New Mexico", "New York",
        "North Carolina", "North Dakota", "Ohio",
        "Oklahoma", "Oregon", "Pennsylvania",
        "Rhode Island", "South Carolina",
        "South Dakota", "Tennessee", "Texas",
        "Utah", "Vermont", "Virginia",
        "Washington", "West Virginia", "Wisconsin",
        "Wyoming"],
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams: {
        name: undefined,
      },
      selectDate:"",
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false
      },
      // 菜单列表
      menuOptions: [],
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        content: [
          {required: true, message: '打招呼内容不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.handleQuery()
  },
  mounted() {
    this.list = this.states.map(item => {
      return { value: `value:${item}`, label: `label:${item}` };
    });
  },
  methods: {

    remoteMethod(query) {
      if (query !== '') {
        this.cityLoading = true;
        getCityOptions({"city":query}).then(res =>{
          this.cityLoading = false;
          this.options = res.data
        })
      } else {
        this.options = [];
      }
    },

    costFormat(row) {
      //1AA 2我请 3你请'
      switch (row.cost) {
        case 1 :
          return "你请"
          break
        case 2 :
          return "AA"
          break
        case 3 :
          return "我请"
          break
      }
    },
    planTimeFormat(row) {
      return row.planStartTime + "-" + row.planEndTime
    },
    handleQuery() {
      this.queryParams.current = this.pagination.page
      this.queryParams.size = this.pagination.limit
      list(this.queryParams).then(response => {
        this.pageList = response.data
        this.pagination.total = response.total
        this.loading = false
      })
    },
    handleResetQuery() {
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.queryParams = {
        name: undefined
      }
      this.selectDate=[]
      this.handleQuery()
    },
    dateChange(){
      if (this.selectDate){
        this.queryParams.planStartTime = this.selectDate[0]
        this.queryParams.planEndTime = this.selectDate[1]
      }
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    handleStatusChange(row) {
      const text = row.status === 1 ? '启用' : '禁用'
      row.status = row.status === 1 ? 0 : 1
      this.$confirm('确认要"' + text + '"数据项吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return patch(row.id, {status: row.status})
      }).then(() => {
        this.$message.success(text + '成功')
        this.handleQuery()
      }).catch(function () {

      })
    },
    handleAdd() {
      this.resetForm()
      this.dialog = {
        title: '新增打招呼',
        visible: true
      }
      //加载虚拟用户选项
      getSimulationOptions().then(res =>{
        this.optionsUser = res.data
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.dialog = {
        title: '修改打招呼',
        visible: true
      }
      const id = row.id || this.ids
      detail(id).then(response => {
        this.form = response.data
      })
    },
    handleDelete(row) {
      const ids = [row.id || this.ids].join(',')
      console.log(this.ids)
      this.$confirm('是否确认删除选中的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        del(ids).then(() => {
          this.$message.success('删除成功')
          this.handleQuery()
        })
      }).catch(() =>
        this.$message.info('已取消删除')
      )
    },
    handleSubmit: function () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const id = this.form.id
          if (id != undefined) {
            update(this.form.id, this.form).then(() => {
              this.$message.success('修改成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          } else {
            add(this.form).then(() => {
              this.$message.success('新增成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {}
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
    }
  }
}
</script>
